// extracted by mini-css-extract-plugin
module.exports = {"messageCol":"Table_messageCol__AB-vK","author":"Table_author__3Yany","authorImage":"Table_authorImage__2Nctl","unreadRow":"Table_unreadRow__3rJaY"};